import BulkInsertDispatcher from './bulk_insert'
import Session from './session'
import EditDispatcher from './edit'
import PresentationEvents from './presentation_events'
import CloseWindowDispatcher from './close_window'
import { disableLabFeatures } from './disable_lab_features'
import { remoteEventDriven } from './remote_event_driven'

export default async (app) => {
  // Similar to capacitor dispathers not loading if you're not in that env
  // maybe we can check if we're in the apps?
  if (app.options.mode !== 'integration') {
    return
  }

  Session(app)
  CloseWindowDispatcher(app)
  BulkInsertDispatcher(app)
  EditDispatcher(app)
  PresentationEvents(app)
  disableLabFeatures(app)
  remoteEventDriven(app)
}
